import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import { CountUp as CountUpModule, CountUpOptions } from 'countup.js';

function isInt(n: number){
    return Number(n) === n && n % 1 === 0;
}

function isFloat(n: number){
    return Number(n) === n && n % 1 !== 0;
}

export default class CountUp extends BaseModule {
    constructor(el: HTMLDivElement, factory: Factory) {
        super(el, factory, 'CountUp');

        el.querySelectorAll<HTMLElement>('.counter')?.forEach((counter, index) => {
            const dataset = counter.dataset;
            const number: number = parseFloat(dataset.number ?? '0');
            const countOptions: CountUpOptions = {
                autoAnimate: true,
                autoAnimateDelay: index * 200,
            };
            if (isFloat(number)) {
                countOptions.decimalPlaces = 1;
            }

            const count = new CountUpModule(counter, number, countOptions);
            count.start();
        });
    }

}